module.exports = __webpack_public_path__ + "img/decor-chevron.5aab1f98.png";